import Model, { attr } from '@ember-data/model';
import type { Type } from '@warp-drive/core-types/symbols';

export default class CustomerModel extends Model {
  declare [Type]: 'customer';
  @attr('string')
  declare name?: string;
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    customer: CustomerModel;
  }
}
